import { Component, OnInit } from '@angular/core';
import { ArrivalService } from '../../Services/arrival.service';
import { AuthService } from '../../Services/auth.service';
import { IMyDpOptions, IMyMarkedDate, IMyDayLabels } from 'mydatepicker';
import Swal from 'sweetalert2'
import * as $ from 'jquery';

@Component({
  selector: 'app-arrival-list',
  template: require('./arrival-list.component.html'),
  styles: [require('./arrival-list.component.css')]
})
export class ArrivalListComponent implements OnInit {
  arrival: any ={}
  AllArrivalList: any[]=[]

  selectedDate: any;
  myDatePickerOptions: IMyDpOptions = {
    todayBtnTxt: 'Vandaag',
    dateFormat: 'dd/mm/yyyy',
    firstDayOfWeek: 'mo',
    sunHighlight: true,
    markCurrentDay: true,
    height: '34px',
    width: '210px',
    alignSelectorRight: false,
    openSelectorTopOfInput: false,
    indicateInvalidDate: true,
    monthSelector: true,
    yearSelector: true,
    minYear: 1920,
    maxYear: 2200,
    componentDisabled: false,
    editableDateField:false,
    showClearDateBtn: true,
    showDecreaseDateBtn: false,
    showIncreaseDateBtn: false,
    showSelectorArrow: true,
    showInputField: true,
    openSelectorOnInputClick: false,
    disableHeaderButtons: true,
    showWeekNumbers: false,
    markDates: [],
    satHighlight: false,
    highlightDates: [],
    markWeekends: <IMyMarkedDate>{},
    monthLabels: {
        1: 'Januari',
        2: 'Februari',
        3: 'Maart',
        4: 'April',
        5: 'Mei',
        6: 'Juni',
        7: 'July',
        8: 'Augustus',
        9: 'September',
        10: 'Oktober',
        11: 'November',
        12: 'December'
    },
    dayLabels: <IMyDayLabels>{
      su: 'zo', mo: 'ma', tu: 'di', we: 'wo', th: 'do', fr: 'vr', sa: 'za'
    },
    allowDeselectDate: true,
    disableWeekdays: [],
    allowSelectionOnlyInCurrentMonth: true
};

  constructor( private arrivalService: ArrivalService, private auth: AuthService) { }

  ngOnInit() {
    this.getAllArrivals();
  }

  NewArrival(){
    this.arrival = {
      "id": -1,
      "date": "",
      "location": ""
    }
    var d = new Date();
    this.selectedDate = {
      jsdate: d,
      date:{year: d.getFullYear(), month: d.getMonth() +1, day: d.getDate()}
    };    
  }

  saveArrival(){
    // console.log(this.arrival)
    this.arrival.date =  String(this.selectedDate.date.year)+"-"+String(this.selectedDate.date.month)+"-"+String(this.selectedDate.date.day),
    this.arrivalService.addToArrival(this.arrival).subscribe(x =>{
      // console.log(x);
      this.getAllArrivals();
    });    
  }

  deleteArrival(id: number){
    Swal.fire({
        title: 'Ben je zeker?',
        text: "Ben je zeker dat je deze aankomst wil verwijderen?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Jep',
        cancelButtonText: 'Nope'
      }).then((result) => {
        if (result.value) {
          this.arrivalService.delete(id).subscribe(x=>{
            // console.log(x)
            this.getAllArrivals();
          })
        }
      });  
  }


  private getAllArrivals(){
     this.arrivalService.getAllArrivals().subscribe(x => {
       this.AllArrivalList = x;
      //  console.log(this.AllArrivalList);
     })
  }

  editArrival(id: number){
    var loc = this.AllArrivalList.find( al => al.id == id)
    this.arrival = loc;
    // console.log("this.arrival", this.arrival);
    
    var t = new Date(this.arrival.date)
    
    this.selectedDate = {
      jsdate: t,
      date:{year: t.getFullYear(), month: t.getMonth() +1, day: t.getDate()}
    };    
    (<any>$('#arrivalModal')).modal();
    
  }

  
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/arrival-list/arrival-list.component.ts